// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__1Ztei","sidebar__subsection":"styles_sidebar__subsection__3SoxK"};